<template>
  <v-list subheader>
    <v-subheader>Profit & Loss</v-subheader>
    <v-list-item @click="openDateSelector('profitAndLoss/standard')">
      <v-list-item-avatar tile>
        <v-img src="@/assets/Report/deficit.png"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Profit & Loss Standard</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider inset></v-divider>
    <v-list-item @click="openDateSelector('profitAndLoss/byProduct')">
      <v-list-item-avatar tile>
        <v-img src="@/assets/Report/business-and-finance.png"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Profit & Loss By Product</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <!-- <v-divider inset></v-divider>
    <v-list-item>
      <v-list-item-avatar tile>
        <v-img src="@/assets/Report/serail.png"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Seriales Item Profit & Loss</v-list-item-title>
      </v-list-item-content>
    </v-list-item> -->
    <v-divider inset></v-divider>
    <v-list-item @click="openDateSelector('profitAndLoss/byCustomer')">
      <v-list-item-avatar tile>
        <v-img src="@/assets/Report/deficit.png"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>Profit & Loss By Customer</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("reportView", ["setDateSelector", "setReportName"]),
    openReport(link) {
      let routeData = this.$router.resolve({
        path: `/reportView/invoice/${link}`,
      });
      window.open(routeData.href, "_blank");
    },
    openDateSelector(val) {
      this.setReportName(val);
      this.setDateSelector(true);
    },
  },
};
</script>

<style scoped></style>
